'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = registerDefaultWidgets;

var _Konsul = require('./Konsul');

var _Konsul2 = _interopRequireDefault(_Konsul);

var _widgets = require('./types/widgets');

var _widgets2 = require('./widgets');

var Widgets = _interopRequireWildcard(_widgets2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WidgetRegisterContract = _widgets.WidgetRegisterContract;


var widgetsRegistration = [{
  widget: Widgets.Text,
  name: 'text',
  options: {
    style: function style(_style, node) {
      if (!(_style instanceof Object)) {
        throw new TypeError('Value of argument "style" violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(_style));
      }

      if (!(node instanceof Widgets.Text)) {
        throw new TypeError('Value of argument "node" violates contract.\n\nExpected:\nWidgets.Text\n\nGot:\n' + _inspect(node));
      }

      return node.setStyle(_style);
    },
    type: function type(_type, node) {
      if (!(typeof _type === 'string')) {
        throw new TypeError('Value of argument "type" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(_type));
      }

      if (!(node instanceof Widgets.Text)) {
        throw new TypeError('Value of argument "node" violates contract.\n\nExpected:\nWidgets.Text\n\nGot:\n' + _inspect(node));
      }

      return node.setType(_type);
    }
  }
}, {
  widget: Widgets.Image,
  name: 'image',
  options: {
    style: function style(_style2, node) {
      if (!(_style2 instanceof Object)) {
        throw new TypeError('Value of argument "style" violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(_style2));
      }

      if (!(node instanceof Widgets.Image)) {
        throw new TypeError('Value of argument "node" violates contract.\n\nExpected:\nWidgets.Image\n\nGot:\n' + _inspect(node));
      }

      return node.setStyle(_style2);
    },
    source: function source(url, node) {
      if (!(typeof url === 'string')) {
        throw new TypeError('Value of argument "url" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(url));
      }

      if (!(node instanceof Widgets.Image)) {
        throw new TypeError('Value of argument "node" violates contract.\n\nExpected:\nWidgets.Image\n\nGot:\n' + _inspect(node));
      }

      return node.setSource(url);
    }
  }
}, {
  widget: Widgets.Container,
  name: 'container'
}, {
  widget: Widgets.Group,
  name: 'group',
  options: {
    name: function name(_name, node) {
      if (!(typeof _name === 'string')) {
        throw new TypeError('Value of argument "name" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(_name));
      }

      if (!(node instanceof Widgets.Group)) {
        throw new TypeError('Value of argument "node" violates contract.\n\nExpected:\nWidgets.Group\n\nGot:\n' + _inspect(node));
      }

      return node.setName(_name);
    }
  }
}, {
  widget: Widgets.Button,
  name: 'button',
  options: {
    label: function label(_label, node) {
      if (!(typeof _label === 'string')) {
        throw new TypeError('Value of argument "label" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(_label));
      }

      if (!(node instanceof Widgets.Group)) {
        throw new TypeError('Value of argument "node" violates contract.\n\nExpected:\nWidgets.Group\n\nGot:\n' + _inspect(node));
      }

      return node.setLabel(_label);
    }
  }
}];

if (!(Array.isArray(widgetsRegistration) && widgetsRegistration.every(function (item) {
  return WidgetRegisterContract(item);
}))) {
  throw new TypeError('Value of variable "widgetsRegistration" violates contract.\n\nExpected:\nWidgetRegisterContract[]\n\nGot:\n' + _inspect(widgetsRegistration));
}

function registerDefaultWidgets(konsul) {
  if (!(konsul instanceof _Konsul2.default)) {
    throw new TypeError('Value of argument "konsul" violates contract.\n\nExpected:\nKonsul\n\nGot:\n' + _inspect(konsul));
  }

  widgetsRegistration.forEach(function (registration) {
    konsul.registerWidget(registration);
  });
}

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : _typeof(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = Object.keys(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : JSON.stringify(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../lib/registerDefaultWidgets.js
// module id = 687
// module chunks = 0